import React from 'react';
import { motion } from 'framer-motion';
import { Frown, TrendingDown, Lock } from 'lucide-react';
export function PainSection() {
  return <section className="py-20 px-4 relative" data-id="element-166">
      <div className="max-w-5xl mx-auto" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-168">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-169">
            It's a horrible feeling, isn't it?
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-170">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="bg-[#12121a] p-8 rounded-2xl border border-white/5 shadow-lg relative overflow-hidden group" data-id="element-171">
            <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-172">
              <Frown className="w-24 h-24 text-white" data-id="element-173" />
            </div>
            <p className="text-xl text-gray-300 italic leading-relaxed relative z-10" data-id="element-174">
              "Walking into a car dealership to buy the vehicle your family
              needs, only for the salesman to come back with a straight face
              saying:{' '}
              <strong className="text-red-400 font-normal" data-id="element-175">
                'I'm sorry, the bank didn't approve your application.'
              </strong>
              "
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-[#12121a] p-8 rounded-2xl border border-white/5 shadow-lg relative overflow-hidden group" data-id="element-176">
            <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-177">
              <Lock className="w-24 h-24 text-white" data-id="element-178" />
            </div>
            <p className="text-xl text-gray-300 italic leading-relaxed relative z-10" data-id="element-179">
              "Or wanting to launch your own business but being stuck in a
              9-to-5 because you don't have the 'score' required to get a
              business line of credit."
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-12 bg-gradient-to-r from-red-900/20 to-transparent p-8 rounded-2xl border-l-4 border-red-500" data-id="element-180">
          <div className="flex items-start gap-4" data-id="element-181">
            <TrendingDown className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-182" />
            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-183">
              Watching inflation rise while your borrowing power drops feels
              like watching your future fade away. You feel blocked, judged by a
              number on a screen that doesn't even reflect who you truly are.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}